import { ICustomer, ICustTypeDto, CustTypeFlags } from '@/interfaces';

export class HELPER {

	public static GetCustomerName(c: ICustomer) {
		var rval: string = '';
		if (this.HasFlag(c, 10)) {
			rval = c.Billing.Company;
		} else {
			rval = `${c.Billing.FName} ${c.Billing.LName}`;
		}
		return rval;
	}

	public static HasFlag(c: ICustomer, id: number): boolean {
		if (!c || !c.CustType || !c.CustType.CustTypeFlags) return false;
		return this.HasFlag2(c.CustType, id);
	}

	public static HasFlag2(c: ICustTypeDto, id: number): boolean {
		if (c==null || c.CustTypeFlags ==null)return false;
		return this.HasFlag3(c.CustTypeFlags, id);
	}

	public static HasFlag3(c: CustTypeFlags[], id: number): boolean {
		if (c==null || c.length==0 )return false;
		var iof = c.indexOf(id);
		var hasIt: boolean = iof > -1;
		return hasIt;
	}


	public static Preserve(name: string, o:any):void{
		var json = JSON.stringify(o);
		window.localStorage.setItem(name,json);
	}

	public static Restore(name: string):any{
		var json = window.localStorage.getItem(name);
		var o = JSON.parse(json);
		return o;
	}


	public static Clone(o:any):any{
		var str =  JSON.stringify(o);
		var rval = JSON.parse(str);
		return rval;
	}


}